import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_black1};
  gap: 32px;
  ${responsive.MOBILE`
    gap: 0;
    background-color: ${COLORS.cirrus_white};
  `}
  .content {
    padding: 24px 16px;
    width: 100%;

    ${responsive.MOBILE`
      padding: 16px 16px;
    `}
  }

  .used-by-client-details {
    padding: 16px;
    display: flex;
    flex-direction: column;
    border: 1px solid ${COLORS.cirrus_black4};
    border-radius: 8px;
    background: ${COLORS.primary_light_blue1};
    height: 80px;
  }

  .parent-tag-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 4px;
  }

  .parent-tag {
    width: 62px;
    height: 20px;
    background: ${COLORS.cirrus_green};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
  }

  .parent-text {
    line-height: 22px;
    color: ${COLORS.cirrus_white};
  }

  .client-name-text {
    line-height: 20px;
    color: ${COLORS.cirrus_black};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .align-center {
    align-items: center;
    justify-content: center;
  }

  .sub-text {
    line-height: 22px;
    color: ${COLORS.cirrus_black8};
  }

  .width-75 {
    width: 75%;
  }

  .full-width {
    width: 100%;
  }

  .contact-type-container {
    display: flex;
    flex-direction: row;
  }

  .checkbox-container {
    p {
      margin-top: 5px;
    }
  }

  .contact-type-dropdown {
    label {
      margin-bottom: 0px;
    }
  }
`;
